import { graphql } from '../../graphql';

export const bulkPaidServices = graphql(`
  query PaidServices($targetIds: [ID!]!) {
    paidServices(targetIds: $targetIds, targetType: ITEM) {
      id
      title
    }
  }
`);

export const bulkPaidServiceOptions = graphql(`
  query PaidServiceOptions($paidServiceId: ID!, $targetIds: [ID!]!) {
    paidServiceOptions(paidServiceId: $paidServiceId, targetIds: $targetIds) {
      id
      name
      price
      priceWithDiscount(paymentMethodId: "wallet")
    }
  }
`);

export const bulkPaymentMethod = graphql(`
  query PaymentMethod($paidServiceId: ID!, $targetIds: [ID!]!) {
    paymentMethods(
      paidServiceId: $paidServiceId
      targetIds: $targetIds
      targetType: ITEM
    ) {
      id
      balance
      name
    }
  }
`);

export const getBulkItems = graphql(`
  query BulkItems($companyId: ID!, $limit: Limit!, $offset: Int!) {
    items(filter: { companyId: $companyId }, limit: $limit, offset: $offset) {
      id
      area {
        value
        units
      }
      leased
      floor
      floors
      city {
        id
        name
      }
      location {
        id
        name
        fullName
      }
      hasMortgage
      hasInternalLoan
      price {
        total
        currency
      }
      company {
        id
        name
        targetType
      }
      paidDaily
      rooms
      hasBillOfSale
      hasRepair
      vipped
      featured
      updatedAt
      path
      photosCount
      photos(limit: 4) {
        thumbnail
        f460x345
        large
      }
    }
  }
`);
